module.exports = __webpack_public_path__ + "img/Hui_SW_22.a20c99f2.jpg";